


































import {
  defineComponent, reactive, toRefs,
} from '@vue/composition-api'
import PageSection from '@/components/layouts/PageSection.vue'
import { vxm } from '@/state/index'
import SessionsList from './pods/SessionsList.vue'
import SessionForm from './pods/SessionForm.vue'

interface SessionData {
  date: string;
  clientId: string;
  therapistId: string;
  note: string;
  dateObj: Date;
}

type State = {
  addingNew: boolean;
  newSession: SessionData;
}

export default defineComponent({
  components: {
    PageSection, SessionsList, SessionForm,
  },

  props: {
    clientId: { type: String, default: '' },
    clientName: { type: String, default: '' },
  },

  setup(props) {
    const now = new Date()
    const state = reactive({
      addingNew: false,
      newSession: {
        date: now.toUTCString(),
        clientId: props.clientId,
        therapistId: vxm.authUser.id ? vxm.authUser.id : '',
        note: '',
        dateObj: now,
      },
    })

    return {
      ...toRefs(state),
    }
  },
})

